import { Intent, Tag, Tooltip } from "@blueprintjs/core";
import css from "./RankPill.module.scss";
import tableCss from "./TableStyles.module.scss";

const GOOD_PERCENTILE_MAX = 33;
const FAIR_PERCENTILE_MAX = 67;

const getIntent = (percentile: number): Intent => {
    if (percentile <= GOOD_PERCENTILE_MAX) return Intent.SUCCESS;
    if (percentile <= FAIR_PERCENTILE_MAX) return Intent.WARNING;
    return Intent.DANGER;
};

const ORDINAL_SUFFIXES = ["th", "st", "nd", "rd"];

const toOrdinal = (n: number): string => {
    const modHundred = n % 100;
    if (modHundred >= 11 && modHundred <= 13) return `${n}th`;
    return `${n}${ORDINAL_SUFFIXES[n % 10] ?? "th"}`;
};

export const RankPill: React.FC<{
    readonly rank: number;
    readonly totalRanked: number;
    readonly percentile: number;
}> = ({ rank, totalRanked, percentile }) => (
    <Tooltip
        content={`${toOrdinal(rank)} out of ${totalRanked} projects`}
        compact
    >
        <Tag
            round
            minimal
            intent={getIntent(percentile)}
            className={css["RankPill"]}
        >
            {`p${percentile}`}
        </Tag>
    </Tooltip>
);

/** The rank pill as a table cell, falling back to a muted dash. */
export const RankCell: React.FC<{
    readonly rank: number | undefined;
    readonly totalRanked: number | undefined;
    readonly percentile: number | undefined;
}> = ({ rank, totalRanked, percentile }) =>
    rank === undefined || percentile === undefined || !totalRanked ? (
        <span className={tableCss["muted-cell"]}>-</span>
    ) : (
        <RankPill
            rank={rank}
            totalRanked={totalRanked}
            percentile={percentile}
        />
    );
